module.exports = __webpack_public_path__ + "img/2.08d9f5ae.jpg";